__turbopack_context__.v({
  "className": "o3H0Oq_className",
  "variable": "o3H0Oq_variable",
});
